import styled, { css } from 'styled-components';
import Button from '../Button/Button.js';

const Nav = styled(Button).attrs({
    variation: 'secondary',
    size: 'medium',
    type: 'button',
})(({ theme: { olist: theme } }) => css `
    border: none;
    cursor: pointer;
    padding: 4px 16px;
    color: ${theme.color.neutral.stronger};
    margin-right: 4px;
    font-weight: ${theme.fontWeight.regular};

    &:hover {
      color: ${theme.color.primary.base};
      background-color: transparent;
      box-shadow: none;
    }
  `);

export { Nav };
